module.exports = __webpack_public_path__ + "public/Icons/right-arrow.png?d664063e";